var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-container-with-nav vouchers"},[_c('ActivitiesList',{attrs:{"dropdownValue":null,"filterItems":_vm.filterOptions,"isVoucher":true,"showPurchasedItems":_vm.showPurchasedItems}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }